import React from 'react';
import {PopupSendMessage} from '../../UnpaidAgents/components/PopupSendMessage/PopupSendMessage';

export function SendMessageToUnpaidAgentColumnFormatter(cellContent) {
  return <PopupSendMessage {...cellContent}/>
}
